import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import React from 'react';
import 'react-toastify/dist/ReactToastify.css';
import RequireAuth from "./components/services/RequireAuth";
import RequireRights from "./components/services/RequireRights";
import ResumeProvider from "./components/services/ResumeProvider";
import ResumeBanner from "./components/ResumeBanner";
import { BreadcrumbProvider } from "./contexts/BreadcrumbContext";
import AddHabilitation from "./pages/accessandrights/AddHabilitation";
import AddProfil from "./pages/accessandrights/AddProfil";
import Habilitations from "./pages/accessandrights/Habilitations";
import Modules from "./pages/accessandrights/Modules";
import ModulesV2 from "./pages/accessandrights/ModulesV2";
import Profils from "./pages/accessandrights/Profils";
import Profile from "./pages/account/Profile";
import ProfileNotifications from "./pages/account/ProfileNotifications";
import ProfileSecurity from "./pages/account/ProfileSecurity";
import AdminAppareils from "./pages/securite/AdminAppareils";
import Assures from "./pages/assures/Assures";
import AssuresV2 from "./pages/assures/AssuresV2";
import AfterRegistrationPage from "./pages/auth/AfterRegistrationPage";
import ConfirmOTP from "./pages/auth/ConfirmOTP";
import FirstConnexion from "./pages/auth/FirstConnexion";
import ForgotPassword from "./pages/auth/ForgotPassword";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import RegisterV2 from "./pages/auth/RegisterV2";
import ResetPassword from "./pages/auth/ResetPassword";
import VerifyEmail from "./pages/auth/VerifyEmail";
import Encaissements from "./pages/caisse/Encaissements";
import RecalculCommissions from "./pages/commissions/RecalculCommissions";
import EtatCaissier from "./pages/caisse/EtatCaissier";
import VersementsEnCompagnie from "./pages/caisse/VersementsEnCompagnie";
import VersementsBancairesVTSync from "./pages/caisse/VersementsBancairesVTSync";
import Home from "./pages/Home";
import HomeV2 from "./pages/HomeV2";
import AllMembres from "./pages/membres/AllMembres";
import AddCourtier from "./pages/membres/courtiers/AddCourtier";
import Courtiers from "./pages/membres/courtiers/Courtiers";
import CourtiersV2 from "./pages/membres/courtiers/CourtiersV2";
import DetailsCourtier from "./pages/membres/courtiers/DetailsCourtier";
import DetailsAgence from "./pages/membres/DetailsAgence";
import SuiviAgences from "./pages/stats/reseau/SuiviAgences";
import SuiviCourtiers from "./pages/stats/reseau/SuiviCourtiers";
import SuiviIntermediaires from "./pages/stats/reseau/SuiviIntermediaires";
import AccreditationCourtiers from "./pages/stats/reseau/AccreditationCourtiers";
import DetailsIntermediaire from "./pages/membres/DetailsIntermediaire";
import DetailsMembre from "./pages/membres/DetailsMembre";
import Intermediaires from "./pages/membres/intermediaires/Intermediaires";
import Cession from "./pages/operations/cessions/Cession";
import Retrocession from "./pages/operations/retrocesions/Retrocession";
import Accessoires from "./pages/parametres/accessoires/Accessoires";
import TypesAttestations from "./pages/parametres/attestations/TypesAttestations";
import AutresParametres from "./pages/parametres/AutresParametres";
import AutresParametresV2 from "./pages/parametres/AutresParametresV2";
import DelaiCorbeille from "./pages/parametres/other-parameters/DelaiCorbeille";
import CessionAnterieurs from "./pages/parametres/other-parameters/CessionAnterieurs";
import Avenants from "./pages/parametres/avenants/Avenants";
import AvenantsV2 from "./pages/parametres/avenants/AvenantsV2";
import Carosseries from "./pages/parametres/carosseries/Carosseries";
import CarrosseriesGenres from "./pages/parametres/engins/CarrosseriesGenres";
import Categories from "./pages/parametres/categories/Categories";
import TauxCommissions from "./pages/parametres/commissions/TauxCommissions";
import TauxCommissionsV2 from "./pages/parametres/commissions/TauxCommissionsV2";
import Energies from "./pages/parametres/conversions/Energies";
import Fractionnements from "./pages/parametres/fractionnements/Fractionnements";
import Garanties from "./pages/parametres/Garanties";
import GarantiesV2 from "./pages/parametres/GarantiesV2";
import Marques from "./pages/parametres/marques/Marques";
import Banques from "./pages/parametres/other-parameters/Banques";
import CausesSinistres from "./pages/parametres/other-parameters/CausesSinistres";
import Etablissements from "./pages/parametres/other-parameters/Etablissements";
import Experts from "./pages/parametres/other-parameters/Experts";
import PointsInvestigation from "./pages/parametres/other-parameters/PointsInvestigation";
import DocumentsAReclamer from "./pages/parametres/other-parameters/DocumentsAReclamer";
import Exercices from "./pages/parametres/other-parameters/Exercices";
import NatureActeV2 from "./pages/parametres/other-parameters/NatureActeV2";
import MotifsExclusionRetrocession from "./pages/parametres/other-parameters/MotifsExclusionRetrocession";
import Prejudices from "./pages/parametres/other-parameters/Prejudices";
import Professions from "./pages/parametres/other-parameters/Professions";
import SommeMinList from "./pages/parametres/other-parameters/SommeMini";
import TypeProfils from "./pages/parametres/other-parameters/TypeProfils";
import Villes from "./pages/parametres/other-parameters/Villes";
import ParametresTarification from "./pages/parametres/ParametresTarification";
import ParametresTarificationV2 from "./pages/parametres/ParametresTarificationV2";
import ParametresSinistres from "./pages/parametres/ParametresSinistres";
import MotifsReglement from "./pages/parametres/sinistres/MotifsReglement";
import DetailsReductions from "./pages/parametres/reductions/DetailsReductions";
import Reductions from "./pages/parametres/reductions/Reductions";
import SousGaranties from "./pages/parametres/SousGaranties";
import SousGarantiesV2 from "./pages/parametres/SousGarantiesV2";
import Taxes from "./pages/parametres/taxes/Taxes";
import Usages from "./pages/parametres/usages/Usages";
import Commandes from "./pages/production/attestations/commandes/Commandes";
import DetailsLotAttestations from "./pages/production/attestations/details-dispatch/DetailsLotAttestations";
import DetailsLotAttestationsDispatched from "./pages/production/attestations/details-dispatch/DetailsLotAttestationsDispatched";
import GestionDesAttestations from "./pages/production/attestations/gestion-des-attestations/GestionDesAttestations";
import EpurationAttestations from "./pages/production/attestations/EpurationAttestations";
import SuppressionLotsAttestations from "./pages/production/attestations/SuppressionLotsAttestations";
import Bordereaux from "./pages/production/Bordereaux";
import AddContrat from "./pages/production/contrats/AddContrat";
import Contrats from "./pages/production/contrats/Contrats";
import DetailsContrat from "./pages/production/contrats/DetailsContrat";
import PrintedContracts from "./pages/production/contrats/PrintedContracts";
import PrintedContractsV2 from "./pages/production/contrats/PrintedContractsV2";
import EtatAttestationsCedeaoImprimees from "./pages/production/contrats/EtatAttestationsCedeaoImprimees";
import EtatAttestationsCimaImprimees from "./pages/production/attestations/EtatAttestationsCimaImprimees";
import Production from "./pages/production/Production";
import ProductionV2 from "./pages/production/ProductionV2";
import STACFileConsumption from "./pages/production/STACFileConsumption";
import DetailsSinistreV2 from "./pages/sinistres/details/DetailsSinistreV2";
import NotificationsHistory from "./pages/notifications/NotificationsHistory";
import EvaluationSinistre from "./pages/sinistres/details/EvaluationSinistre";
import Inventaires from "./pages/sinistres/inventaires/Inventaires";
import ListSinistres from "./pages/sinistres/ListSinistres";
import ListSinistresV2 from "./pages/sinistres/ListSinistresV2";
import RegularisationSap from "./pages/sinistres/RegularisationSap";
import ListingRecours from "./pages/sinistres/ListingRecours";
import SinistresPayesParCompagnie from "./pages/sinistres/SinistresPayesParCompagnie";
import DossiersSinistres from "./pages/sinistres/DossiersSinistres";
import ValidationEvaluationsV2 from "./pages/sinistres/ValidationEvaluationsV2";
import VerificationJustificatifsPool from "./pages/sinistres/VerificationJustificatifsPool";
import ValidationDecaissementsV2 from "./pages/sinistres/ValidationDecaissementsV2";
import ValidationDecaissements from "./pages/sinistres/ValidationDecaissements";
import ValidationEvaluations from "./pages/sinistres/ValidationEvaluations";
import EtatsProductionGlobal from "./pages/stats/production/EtatsProductionGlobal";
import EtatsProductionGlobalV2 from "./pages/stats/production/EtatsProductionGlobalV2";
import AddUtilisateur from "./pages/utilisateurs/AddUtilisateur";
import NewAddUtilisateur from "./pages/utilisateurs/NewAddUtilisateur";
import DetailsUtilisateur from "./pages/utilisateurs/DetailsUtilisateur";
import Utilisateurs from "./pages/utilisateurs/Utilisateurs";
import NosCommandes from "./pages/production/attestations/commandes/NosCommandes";
import CompaniesCommandes from "./pages/production/attestations/commandes/CompaniesCommandes";
import CheckAuthenticity from "./pages/certificate-download-platform/CheckAuthenticity";
import DownloadCertificates from "./pages/certificate-download-platform/DownloadCertificates";
import DetailsCompagnie from "./pages/production/attestations/commandes/details/DetailsCompagnie";
import ProduitAttestation from "./pages/parametres/produit-attestation/ProduitAttestation";
import Attestations from "./pages/caisse/Attestations";
import ReglementAttestation from "./pages/caisse/pages/ReglementAttestation";
import MobileAppDownloadPage from "./pages/mobile-app/MobileAppDownloadPage";
import MobileAppReleasesAdmin from "./pages/mobile-app/MobileAppReleasesAdmin";
import RequireOTP from "./components/services/RequireOTP";
import AgenceCommande from "./pages/production/attestations/commandes/details/AgenceCommande";
import Balance from "./pages/comptabilite/Balance";
import Comptes from "./pages/comptabilite/Comptes";
import TcaAReverser from "./pages/comptabilite/fiscalite/TcaAReverser";
import RetenuesHonoraires from "./pages/comptabilite/fiscalite/RetenuesHonoraires";
import RetenuesCommissions from "./pages/comptabilite/fiscalite/RetenuesCommissions";
import RegisterEtablissement from "./pages/auth/RegisterEtablissement";
import MigrationDeclarationSinistre from "./pages/migration/MigrationDeclarationSinistre";
import MigrationSinistrePayes from "./pages/migration/MigrationSinistrePayes";
import MigrationProduction from "./pages/migration/MigrationProduction";
import MigrationProvisionsEtatsDossiers from "./pages/migration/MigrationProvisionsEtatsDossiers";
import EtatsSinistres from "./pages/stats/sinistre/EtatsSinistres";
import EtatsSinistresV2 from "./pages/stats/sinistre/EtatsSinistresV2";
import AddLieu from "./pages/parametres/other-parameters/AddLieu";
import BaremeEvaluationOuvertureSinistre from "./pages/parametres/other-parameters/bareme-sinistre/BaremeEvaluationOuvertureSinistre";
import DetailsLotAttestationsAgence from "./pages/production/attestations/DetailsLotAttestationsAgence";
import SuiviLotsParAgence from "./pages/production/attestations/SuiviLotsParAgence";
import CommandeAutorise from "./pages/production/attestations/commandes/CommandeAutorise";
import CommandeDelivre from "./pages/production/attestations/commandes/CommandeDelivre";
import CommandeRejete from "./pages/production/attestations/commandes/CommandeRejete";
import CommandeValides from "./pages/production/attestations/commandes/CommandeValides";
import CommandeConfirme from "./pages/production/attestations/commandes/CommandeConfirme";
import CommandeReception from "./pages/production/attestations/commandes/CommandeReception";
import CleDeRepartition from "./pages/parametres/other-parameters/cles/CleDeRepartition";
import EntiteConstats from "./pages/parametres/entiteConstat/EntiteConstats";
import AddOldContratGUM from "./pages/production/contrats/AddOldContratGUM";
import NonPrintedContrats from "./pages/production/contrats/NonPrintedContrats";
import AllRoutes from "./pages/accessandrights/AllRoutes";
import EnAttenteDEncaissement from "./pages/caisse/EnAttenteDEncaissement";
import EnAttenteDEncaissementV2 from "./pages/caisse/EnAttenteDEncaissementV2";
import Parametrage from "./pages/comptabilite/Parametrage";
import NumeroConfig from "./pages/parametres/other-parameters/NumeroConfig";
import NumeroPoliceAddPage from "./pages/parametres/other-parameters/NumeroPoliceAddPage";
import NumeroSinistreAddPage from "./pages/parametres/other-parameters/NumeroSinistreAddPage";
import TransactionsMobileMoney from "./pages/production/components/TransactionsMobileMoney";
import TypePieces from "./pages/parametres/other-parameters/TypePieces";
import NouvelleConventionCollaboration from "./pages/membres/courtiers/NouvelleConventionCollaboration";
import Propositions from "./pages/production/contrats/Propositions";
import PropositionsV2 from "./pages/production/contrats/PropositionsV2";
import CorbeillePropositions from "./pages/production/contrats/CorbeillePropositions";
import TypeEtablissements from "./pages/parametres/other-parameters/TypeEtablissements";
import TypeEtablissementsV2 from "./pages/parametres/other-parameters/TypeEtablissementsV2";
import BorderauReversement from "./pages/caisse/BorderauReversement";
import ListAgeLimitePaiementRente from "./pages/parametres/agelimiteRente/ListAgeLimitePaiementRente";
import Smigs from "./pages/parametres/smig/Smigs";
import PretiumDoloris from "./pages/parametres/pretiumDoloris/PretiumDoloris";
import ValeurPointIP from "./pages/parametres/valeurPoint/ValeurPointIP";
import ValeurPointIPV2 from "./pages/parametres/valeurPoint/v2/ValeurPointIPV2";
import SignatairesDocuments from "./pages/parametres/SignatairesDocuments";
import GrandLivre from "./pages/comptabilite/GrandLivre";
import CommissionsGenerees from "./pages/caisse/commissions/CommissionsGenerees";
import DeclarationSinistreForm from "./pages/sinistres/DeclarationSinistreForm";
import DeclareSinistre from "./pages/sinistres/DeclareSinistre";
import NewAddContrat from "./pages/production/contrats/NewAddContrat";
import QrCodeGenerator from "./utils/QrCodeGenerator";
import GestionPaiementSinistreExperts from "./pages/sinistres/GestionPaiementSinistreExperts";
import GestionPaiementSinistreExpertsV2 from "./pages/sinistres/GestionPaiementSinistreExpertsV2";
import InsuranceVerification from "./pages/verifications/InsuranceVerification";
import LogsViewer from "./pages/logs/LogsViewer";
import TokenExpirationModal from "./components/services/TokenExpirationModal";
import EnvironmentBadge from "./components/EnvironmentBadge";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CessionsPool from "./pages/operations/cessions/CessionsPool";
import DashboardProduction from "./pages/stats/analytics/production/DashboardProduction";
import ClesRepartition from "./pages/parametres/other-parameters/cles/ClesRepartition";
import ClesRepartitionV2 from "./pages/parametres/other-parameters/cles/ClesRepartitionV2";
import SimulationCleRepartition from "./pages/parametres/other-parameters/cles/SimulationCleRepartition";
import PenalitesCession from "./pages/parametres/other-parameters/PenaliteCession";
import EtatsSinistresModerne from "./pages/stats/sinistre/EtatsSinistresModerne";
import StatistiquesSAP from "./pages/stats/sinistre/sap/StatistiquesSAP";
import StatistiquesSAPV2 from "./pages/stats/sinistre/sap/StatistiquesSAPV2";
import PrimeAReporterEtat from "./pages/stats/production/PrimeAReporterEtat";
import CommissionTechnique from "./pages/commission/CommissionTechnique";
import CommissionProduction from "./pages/commission/CommissionProduction";
import StatistiquesProduction from "./pages/stats/production/agency-production/StatistiquesProduction";
import BulkEmailSender from "./pages/mailing/BulkEmailSender";
import Retrocessions from "./pages/operations/retrocesions/Retrocessions";
import ClesRetrocessionConsultation from "./pages/operations/retrocesions/ClesRetrocessionConsultation";
import PrimesReportees from "./pages/operations/retrocesions/PrimesReportees";
import RetrocessionDocuments from "./pages/operations/retrocesions/RetrocessionDocuments";
import UserLogging from "./pages/logs/UserLogging";
import ActivityLogs from "./pages/logs/ActivityLogs";
import SuiviSynchronisations from "./pages/logs/SuiviSynchronisations";
import VideoTutorialsPage from "./pages/documentation/VideoTutorialsPage";
import GestionPaiementSinistreEntitesConstat from "./pages/sinistres/GestionPaiementSinistreEntitesConstat";
import GestionPaiementSinistreEntitesConstatV2 from "./pages/sinistres/GestionPaiementSinistreEntitesConstatV2";
import GestionPaiementSinistreConseilsJuridiquesV2 from "./pages/sinistres/GestionPaiementSinistreConseilsJuridiquesV2";
import GestionPaiementSinistreEtablissementsV2 from "./pages/sinistres/GestionPaiementSinistreEtablissementsV2";
import ConseilsJuridiques from "./pages/parametres/conseilJuridique/ConseilsJuridiques";
import PlafondsConseilsJuridiques from "./pages/sinistres/PlafondsConseilsJuridiques";
import Juridictions from "./pages/parametres/juridiction/Juridictions";

function App() {
    return (
        <div>
            <EnvironmentBadge />
            <BrowserRouter>
                <BreadcrumbProvider>
                <ResumeProvider>
                    <ToastContainer position="top-center" />
                    <ResumeBanner />
                    {/* Ajouter le modal d'expiration du token */}
                    <TokenExpirationModal />
                    <Routes>
                        <Route element={<RequireOTP />}>
                            <Route element={<RequireRights codeHabilitation={"HPE033"} />}>
                                <Route path="/ajouter-utilisateur" element={<NewAddUtilisateur />} />
                                <Route path="/ajouter-utilisateur/:codeAgence" element={<NewAddUtilisateur />} />
                                <Route
                                    path="/details-utilisateur/:utilisateurId"
                                    element={<DetailsUtilisateur />}
                                />
                                <Route path="/utilisateurs" element={<Utilisateurs />} />
                            </Route>

                            <Route
                                path="/video-tutorials"
                                element={<VideoTutorialsPage />}
                            />

                            {/* Etats et statistiques */}
                            <Route
                                path="/etats/production-globale"
                                element={<EtatsProductionGlobalV2 />}
                            />
                            <Route
                                path="/etats/production-globale/v2"
                                element={<EtatsProductionGlobalV2 />}
                            />
                            <Route
                                path="/etats/production-globale/classique"
                                element={<EtatsProductionGlobal />}
                            />

                            <Route
                                path="/stats/production-globale"
                                element={<DashboardProduction />}
                            />

                            <Route
                                path="/stats/sinistres"
                                element={<EtatsSinistresModerne />}
                            />

                            <Route
                                path="/commission-technique"
                                element={<CommissionTechnique />}
                            />
                            <Route
                                path="/commission-technique-production"
                                element={<CommissionProduction />}
                            />
                            {/* /stats/sap-sinistres MIGRÉ vers la v2 (l'ancien reste sur /v1). */}
                            <Route
                                path="/stats/sap-sinistres"
                                element={<StatistiquesSAPV2 />}
                            />
                            <Route
                                path="/stats/sap-sinistres/v1"
                                element={<StatistiquesSAP />}
                            />
                            <Route
                                path="/stats/sap-sinistres/v2"
                                element={<StatistiquesSAPV2 />}
                            />
                            <Route
                                path="/stats/primes-a-reporter"
                                element={<PrimeAReporterEtat />}
                            />

                            <Route
                                path="/stats/agence-prod"
                                element={<StatistiquesProduction />}
                            />

                            <Route
                                path="/logs"
                                element={<LogsViewer />}
                            />

                            <Route
                                path="/logs-users"
                                element={<UserLogging />}
                            />

                            <Route
                                path="/activity-logs"
                                element={<ActivityLogs />}
                            />

                            <Route
                                path="/synchronisations"
                                element={<SuiviSynchronisations />}
                            />

                            <Route
                                path="/autre-parametres/entites-constat"
                                element={<EntiteConstats />}
                            />
                            {/* EtatsSinistresV2 est désormais l'écran par défaut. */}
                            <Route path="/etats/sinistres" element={<EtatsSinistresV2 />} />
                            <Route path="/etats/sinistres/v2" element={<EtatsSinistresV2 />} />
                            {/* Ancien écran conservé pour rollback éventuel. */}
                            <Route path="/etats/sinistres/classique" element={<EtatsSinistres />} />
                            {/* Fin Etats et statistiques */}
                            <Route
                                path="/autre-parametres/professions"
                                element={<Professions />}
                            />
                            <Route path="/autre-parametres/villes" element={<Villes />} />
                            <Route path="/autre-parametres/lieux" element={<AddLieu />} />
                            <Route path="/autre-parametres/banques" element={<Banques />} />

                            <Route path="/autre-parametres/exercices" element={<Exercices />} />
                            <Route
                                path="/autre-parametres/type-profils"
                                element={<TypeProfils />}
                            />
                            <Route
                                path="/autre-parametres/produits-attestation"
                                element={<ProduitAttestation />}
                            />
                            <Route
                                path="/autre-parametres/bareme-evaluation"
                                element={<BaremeEvaluationOuvertureSinistre />}
                            />
                            <Route
                                path="/autre-parametres/cles-de-repartition"
                                element={<CleDeRepartition />}
                            />
                            <Route
                                path="/autre-parametres/cle-de-repartition"
                                element={<ClesRepartition />}
                            />
                            <Route
                                path="/autre-parametres/cle-de-repartition/v2"
                                element={<ClesRepartitionV2 />}
                            />
                            <Route
                                path="/autre-parametres/cle-de-repartition/simulation"
                                element={<SimulationCleRepartition />}
                            />
                            <Route
                                path="/sous-garanties/:garantieId"
                                element={<SousGarantiesV2 />}
                            />

                            <Route
                                path="/autre-parametres/cause-sinistres"
                                element={<CausesSinistres />}
                            />
                            <Route
                                path="/autre-parametres/prejudices"
                                element={<Prejudices />}
                            />
                            <Route
                                path="/autre-parametres/etablisements"
                                element={<Etablissements />}
                            />
                            <Route
                                path="/autre-parametres/type-etablissements"
                                element={<TypeEtablissements />}
                            />
                            <Route
                                path="/autre-parametres/type-etablissements/v2"
                                element={<TypeEtablissementsV2 />}
                            />
                            <Route
                                path="/autre-parametres/autre-parametre"
                                element={<AutresParametres />}
                            />
                            <Route
                                path="/autre-parametres/delai-corbeille"
                                element={<DelaiCorbeille />}
                            />
                            <Route
                                path="/autre-parametres/cession-anterieurs"
                                element={<CessionAnterieurs />}
                            />

                            <Route
                                path="/autre-parametres/nature-acte"
                                element={<NatureActeV2 />}
                            />
                            <Route
                                path="/autre-parametres/nature-acte/v2"
                                element={<NatureActeV2 />}
                            />
                            <Route
                                path="/autre-parametres/motifs-exclusion-retrocession"
                                element={<MotifsExclusionRetrocession />}
                            />
                            <Route
                                path="/autre-parametres/somme-minimale-a-payer"
                                element={<SommeMinList />}
                            />
                            <Route
                                path="/autre-parametres/type-pieces"
                                element={<TypePieces />}
                            />
                            <Route path="/autre-parametres/experts" element={<Experts />} />
                            <Route path="/autre-parametres/points-investigation" element={<PointsInvestigation />} />
                            <Route path="/autre-parametres/documents-a-reclamer" element={<DocumentsAReclamer />} />

                            <Route path="/autre-parametres/numero-config" element={<NumeroConfig />} />
                            <Route path="/transactions-mobile-money" element={<TransactionsMobileMoney />} />

                            <Route path="/autre-parametres/numero-police" element={<NumeroPoliceAddPage />} />
                            <Route path="/autre-parametres/numero-sinistre" element={<NumeroSinistreAddPage />} />


                            <Route path="/garanties" element={<GarantiesV2 />} />
                            <Route
                                path="/parametres/types-attestations"
                                element={<TypesAttestations />}
                            />
                            <Route
                                path="/parametres/taux-commissions"
                                element={<TauxCommissions />}
                            />
                            {/* Taux de commissions v2 (menu v2) : même logique, UI modernisée */}
                            <Route
                                path="/parametres/taux-commissions/v2"
                                element={<TauxCommissionsV2 />}
                            />
                            <Route path="/parametres/avenants" element={<AvenantsV2 />} />
                            {/* <Route path="/ajouter-avenant" element={<AddAvenant />} /> */}
                            <Route path="/parametres/carosseries" element={<Carosseries />} />
                            <Route path="/parametres/engins-parametres" element={<CarrosseriesGenres />} />
                            <Route path="/parametres/taxes" element={<Taxes />} />
                            <Route path="/parametres/marques" element={<Marques />} />
                            <Route path="/parametres/accessoires" element={<Accessoires />} />
                            <Route path="/parametres/conversion" element={<Energies />} />
                            {/* <Route path="/ajouter-energie" element={<AddEnergie />} /> */}
                            <Route path="/parametres/Usages" element={<Usages />} Route />
                            {/* <Route path="/ajouter-energie" element={<AddEnergie />} /> */}

                            <Route
                                path="/details-reduction/:reductionId"
                                element={<DetailsReductions />}
                            />
                            <Route path="/reductions" element={<Reductions />} />
                            <Route path="/categories" element={<Categories />} />
                            {/* <Route path="ajouter-categorie" element={<AddCategorie />} /> */}
                            <Route
                                path="/parametres/fractionnements"
                                element={<Fractionnements />}
                            />
                            {/* <Route path="ajouter-fractionement" element={<AddFractionnement />} /> */}
                            <Route path="/tarification" element={<ParametresTarification />} />
                            {/* Tarification v2 (menu v2) : hub modernisé, sans intermédiaires/courtiers/taux commissions */}
                            <Route path="/tarification/v2" element={<ParametresTarificationV2 />} />
                            <Route path="/parametres/sinistres" element={<ParametresSinistres />} />
                            <Route path="/parametres/motifs-reglement" element={<MotifsReglement />} />
                            {/* v2 PROMUE en prod (hub modernisé) ; v1 conservée sur /v1 pour rollback. */}
                            <Route path="/autres-parametres" element={<AutresParametresV2 />} />
                            <Route path="/autres-parametres/v1" element={<AutresParametres />} />
                            <Route path="/autres-parametres/v2" element={<AutresParametresV2 />} />
                            <Route path="/autre-parametres/v2" element={<AutresParametresV2 />} />
                            <Route
                                path="/details-contrat/:contratId"
                                element={<DetailsContrat />}
                            />
                            <Route
                                path="/ajouter-contrat"
                                element={
                                    <AddContrat />
                                }
                            />
                            <Route
                                path="/editer-contrat/:contratId"
                                element={
                                    <AddContrat />
                                }
                            />
                            <Route
                                path="/ancien-contrat-gum"
                                element={
                                    <AddOldContratGUM />
                                }
                            />
                            <Route element={<RequireRights codeHabilitation={"HCO021"} />}>
                                <Route
                                    path="/production/port"
                                    element={<STACFileConsumption />}
                                />
                            </Route>
                            <Route
                                path="/mes-attestations"
                                element={<DetailsLotAttestations />}
                            />
                            <Route
                                path="/lots-attestations/:codeCompagnie"
                                element={<DetailsLotAttestations />}
                            />
                            <Route
                                path="/gestion-des-attestations"
                                element={<GestionDesAttestations />}
                            />
                            <Route path="/epuration-attestations" element={<EpurationAttestations />} />
                            <Route path="/suppression-lots-attestations" element={<SuppressionLotsAttestations />} />
                            {/*<Route path="/commandes" element={<Commandes/>}/>*/}
                            <Route path="/nos-commandes" element={<NosCommandes />} />
                            <Route
                                path="/compagnies-commandes"
                                element={<CompaniesCommandes />}
                            />
                            <Route
                                path={"/commande/:commandeId"}
                                element={<DetailsCompagnie />}
                            />
                            <Route path={"/commandes"} element={<AgenceCommande />} />
                            <Route
                                path="/details-reduction/:reductionId"
                                element={<DetailsReductions />}
                            />
                            <Route path="/reductions" element={<Reductions />} />
                            <Route path="/categories" element={<Categories />} />
                            {/* <Route path="ajouter-categorie" element={<AddCategorie />} /> */}
                            <Route
                                path="/parametres/fractionnements"
                                element={<Fractionnements />}
                            />
                            {/* <Route path="ajouter-fractionement" element={<AddFractionnement />} /> */}
                            <Route path="/tarification" element={<ParametresTarification />} />
                            {/* Tarification v2 (menu v2) : hub modernisé, sans intermédiaires/courtiers/taux commissions */}
                            <Route path="/tarification/v2" element={<ParametresTarificationV2 />} />
                            <Route path="/parametres/sinistres" element={<ParametresSinistres />} />
                            <Route path="/parametres/motifs-reglement" element={<MotifsReglement />} />
                            {/* v2 PROMUE en prod (hub modernisé) ; v1 conservée sur /v1 pour rollback. */}
                            <Route path="/autres-parametres" element={<AutresParametresV2 />} />
                            <Route path="/autres-parametres/v1" element={<AutresParametres />} />
                            <Route path="/autres-parametres/v2" element={<AutresParametresV2 />} />
                            <Route path="/autre-parametres/v2" element={<AutresParametresV2 />} />
                            <Route
                                path="/details-contrat/:contratId"
                                element={<DetailsContrat />}
                            />
                            <Route path="/ajouter-contrat-new" element={<NewAddContrat />} />
                            <Route
                                path="/editer-contrat-new/:contratId"
                                element={
                                    <NewAddContrat />
                                }
                            />
                            <Route element={<RequireRights codeHabilitation={"HCO021"} />}>
                                <Route
                                    path="/production/port"
                                    element={<STACFileConsumption />}
                                />
                            </Route>
                            <Route
                                path="/dispatching-lot-attestation/:lotAttestationId"
                                element={<DetailsLotAttestationsDispatched />}
                            />
                            <Route
                                path="/dispatched-lots-attestations/:codeAgence"
                                element={<DetailsLotAttestationsAgence />}
                            />
                            <Route
                                path="/suivi-lots-par-agence/:codeCompagnie"
                                element={<SuiviLotsParAgence />}
                            />
                            <Route
                                path="/gestion-des-attestations"
                                element={<GestionDesAttestations />}
                            />
                            <Route path="/epuration-attestations" element={<EpurationAttestations />} />
                            <Route path="/suppression-lots-attestations" element={<SuppressionLotsAttestations />} />
                            <Route path="/commandes" element={<Commandes />} />
                            <Route path="/nos-commandes" element={<NosCommandes />} />
                            <Route
                                path="/compagnies-commandes"
                                element={<CompaniesCommandes />}
                            />
                            <Route
                                path="/commandes-Autorisées"
                                element={<CommandeAutorise />}
                            />
                            <Route path="/commandes-Delivrées" element={<CommandeDelivre />} />
                            <Route
                                path="/commandes-confirmées"
                                element={<CommandeConfirme />}
                            />
                            <Route path="/commande-Rejetées" element={<CommandeRejete />} />
                            <Route
                                path="/commandes-receptionnées"
                                element={<CommandeReception />}
                            />
                            <Route path="/commandes-validées" element={<CommandeValides />} />

                            {/* Opérations */}
                            <Route path="/cession" element={<Cession />} />
                            {/* <Route path="/toutes-les-cessions" element={<CessionsUnifiees />} /> */}
                            <Route path="/toutes-les-cessions" element={<CessionsPool />} />
                            <Route path="/retrocession" element={<Retrocession />} />
                            <Route path="/retrocessions" element={<Retrocessions />} />
                            <Route path="/cles-de-retrocession" element={<ClesRetrocessionConsultation />} />
                            <Route path="/emissions-reportees" element={<PrimesReportees />} />
                            <Route path="/retrocessions-documents" element={<RetrocessionDocuments />} />

                            {/* Migration : /production sert désormais la v2 ; ancienne page conservée en /production/v1 (repli). */}
                            <Route path="/production" element={<ProductionV2 />} />
                            <Route path="/production/v2" element={<ProductionV2 />} />
                            <Route path="/production/v1" element={<Production />} />
                            {/* Production v3 (menu v2) : UI de la v2, mais uniquement des contrats (propositions exclues) */}
                            <Route path="/production/v3" element={<ProductionV2 exclurePropositions />} />
                            {/* Suivi agence (menu v2) : dashboard CA/commissions/reversements par agence */}
                            <Route path="/reseau/suivi-agences" element={<SuiviAgences />} />
                            {/* Suivi courtier (menu v2) : même dashboard restreint aux courtiers */}
                            <Route path="/reseau/suivi-courtiers" element={<SuiviCourtiers />} />
                            {/* Gestion des courtiers (v2 de /courtiers) : liste + fiches + import de la liste officielle */}
                            <Route path="/reseau/courtiers" element={<CourtiersV2 />} />
                            {/* Suivi intermédiaires (menu v2) : même dashboard agrégé par intermédiaire */}
                            <Route path="/reseau/suivi-intermediaires" element={<SuiviIntermediaires />} />
                            {/* Accréditation courtier (menu v2) : courtiers avec agréments à valider */}
                            <Route path="/reseau/accreditation-courtiers" element={<AccreditationCourtiers />} />
                            <Route path="/assures" element={<Assures />} />
                            <Route path="/assures/v2" element={<AssuresV2 />} />
                            {/* Migré vers la v2 ; ancien écran conservé en /v1 pour rollback */}
                            <Route path={"/liste-des-sinistres"} element={<ListSinistresV2 />} />
                            <Route path={"/liste-des-sinistres/v1"} element={<ListSinistres />} />
                            <Route path={"/liste-des-sinistres/v2"} element={<ListSinistresV2 />} />
                            <Route path={"/listing-des-recours"} element={<ListingRecours />} />
                            {/* Régularisation SAP compagnies (import Excel 31/12/2025) — réservé Pool (HSI115). */}
                            <Route element={<RequireRights codeHabilitation={"HSI115"} />}>
                                <Route path={"/regularisation-sap"} element={<RegularisationSap />} />
                            </Route>
                            <Route path={"/etats/sinistres-payes-compagnie"} element={<SinistresPayesParCompagnie />} />
                            {/* Écran fusionné (menu v2) : Sinistres / Instruction / Listing évaluations */}
                            <Route path={"/sinistres/dossiers"} element={<DossiersSinistres />} />
                            {/* v2 passée en prod : la route classique rend désormais la vue V2 (même state codeId). */}
                            <Route path={"/details-sinistre"} element={<DetailsSinistreV2 />} />
                            <Route path={"/details-sinistre/v2"} element={<DetailsSinistreV2 />} />
                            <Route path={"/paiements-sinistre-expert"} element={<GestionPaiementSinistreExperts />} />
                            <Route path={"/paiements-sinistre-expert/v2"} element={<GestionPaiementSinistreExpertsV2 />} />
                            <Route path={"/paiements-sinistre-entites"} element={<GestionPaiementSinistreEntitesConstat />} />
                            <Route path={"/paiements-sinistre-conseil-juridique/v2"} element={<GestionPaiementSinistreConseilsJuridiquesV2 />} />
                            <Route path={"/paiements-sinistre-etablissement/v2"} element={<GestionPaiementSinistreEtablissementsV2 />} />
                            <Route path={"/parametres/conseils-juridiques"} element={<ConseilsJuridiques />} />
                            <Route path={"/plafonds-conseils-juridiques"} element={<PlafondsConseilsJuridiques />} />
                            <Route path={"/parametres/juridictions"} element={<Juridictions />} />
                            <Route path={"/paiements-sinistre-entites/v2"} element={<GestionPaiementSinistreEntitesConstatV2 />} />
                            <Route
                                path={"/validation-decaissement"}
                                element={<ValidationDecaissements />}
                            />
                            {/* Listing des règlements v2 (menu v2) : UI moderne + filtres serveur */}
                            <Route
                                path={"/validation-decaissement/v2"}
                                element={<ValidationDecaissementsV2 />}
                            />
                            <Route path={"/caisse/attestations"} element={<Attestations />} />
                            <Route
                                path={"/caisse/attestation/:commandeId"}
                                element={<ReglementAttestation />}
                            />
                            <Route path={"/parametres/age-limite-paiement-rente"} element={<ListAgeLimitePaiementRente />} />
                            <Route path={"/parametres/penalite-cession"} element={<PenalitesCession />} />
                            <Route
                                path={"/validation-evaluation"}
                                element={<ValidationEvaluations />}
                            />
                            {/* Listing des évaluations v2 (menu v2) : UI moderne + filtre dates serveur */}
                            <Route
                                path={"/validation-evaluation/v2"}
                                element={<ValidationEvaluationsV2 />}
                            />
                            <Route
                                path={"/verification-justificatifs"}
                                element={<VerificationJustificatifsPool />}
                            />
                            <Route
                                path={"/declare-sinister"}
                                element={<DeclarationSinistreForm />}
                            />
                            <Route
                                path={"/declarer-sinister"}
                                element={<DeclareSinistre />}
                            />
                            <Route path={"/parametres/pretium-doloris"} element={<PretiumDoloris />} />
                            <Route path={"/inventaires"} element={<Inventaires />} />
                            <Route
                                path={"/evaluation-sinistre"}
                                element={<EvaluationSinistre />}
                            />

                            <Route path="/parametres/ajouter-valeur-point-ip" element={<ValeurPointIP />} />
                            <Route path="/parametres/ajouter-valeur-point-ip/v2" element={<ValeurPointIPV2 />} />
                            <Route path="/parametres/signataires-documents" element={<SignatairesDocuments />} />

                            <Route path="/ajouter-courtier" element={<AddCourtier />} />
                            <Route path="/courtiers" element={<Courtiers />} />
                            <Route path="/contrats-imprimes" element={<PrintedContracts />} />
                            <Route path="/contrats-imprimes/v2" element={<PrintedContractsV2 />} />
                            <Route path="/attestations-cedeao-imprimees" element={<EtatAttestationsCedeaoImprimees />} />
                            <Route path="/attestations-cima-imprimees" element={<EtatAttestationsCimaImprimees />} />
                            <Route path="/contrats-non-imprimes" element={<NonPrintedContrats />} />
                            <Route path="/contrats" element={<Contrats />} />
                            <Route path="/notifications" element={<NotificationsHistory />} />
                            {/* Migration : /propositions sert désormais la v2 ; ancienne page conservée en /propositions/v1 (repli). */}
                            <Route path="/propositions" element={<PropositionsV2 />} />
                            <Route path="/propositions/v2" element={<PropositionsV2 />} />
                            <Route path="/propositions/v1" element={<Propositions />} />
                            <Route path="/corbeille-propositions" element={<CorbeillePropositions />} />
                            <Route
                                path="/intermediaire/:codeIntermediaire"
                                element={<DetailsIntermediaire />}
                            />
                            <Route path="/parametres/smig" element={<Smigs />} />
                            <Route path="/courtier/:courtierId" element={<DetailsCourtier />} />
                            <Route path="/intermediaires" element={<Intermediaires />} />
                            <Route path="/mon-agence" element={<DetailsAgence />} />
                            <Route path="/agence" element={<DetailsAgence />} />
                            <Route path="/ma-compagnie" element={<DetailsMembre />} />
                            <Route path="/membre/:organismeCode" element={<DetailsMembre />} />
                            <Route path="/membres" element={<AllMembres />} />
                            <Route path="/profils" element={<Profils />} />
                            <Route path="/modifier-profil/:profilId" element={<AddProfil />} />
                            <Route path="/ajouter-profil" element={<AddProfil />} />
                            <Route path="/routes" element={<AllRoutes />} />
                            {/* Migration : /production sert désormais la v2 ; ancienne page conservée en /production/v1 (repli). */}
                            <Route path="/production" element={<ProductionV2 />} />
                            <Route path="/production/v2" element={<ProductionV2 />} />
                            <Route path="/production/v1" element={<Production />} />
                            <Route path="/assures" element={<Assures />} />
                            <Route path="/assures/v2" element={<AssuresV2 />} />
                            <Route path="/encaissements" element={<Encaissements />} />
                            {/* Encaissements v2 (menu v2) : uniquement les règlements encaissés */}
                            <Route path="/encaissements/v2" element={<Encaissements lockStatut="PAID" />} />
                            {/* État de caisse par caissier : réunit encaissements de primes ET
                                versements en compagnie dans un seul document (aperçu + exports). */}
                            <Route path="/caisse/etat-caissier" element={<EtatCaissier />} />
                            <Route path="/en-attente-d-encaissement" element={<EnAttenteDEncaissement />} />
                            {/* En-attente v2 (menu v2) : déjà uniquement les non-effectués (filtre SQL), UI épurée */}
                            <Route path="/en-attente-d-encaissement/v2" element={<EnAttenteDEncaissementV2 />} />
                            <Route
                                path="/versements-en-compagnie"
                                element={<VersementsEnCompagnie />}
                            />
                            <Route
                                path="/borderaux-de-versement-en-compagnie"
                                element={<BorderauReversement />}
                            />
                            <Route
                                path="/vt/versements-bancaires"
                                element={<VersementsBancairesVTSync />}
                            />
                            {/* Migration : /production sert désormais la v2 ; ancienne page conservée en /production/v1 (repli). */}
                            <Route path="/production" element={<ProductionV2 />} />
                            <Route path="/production/v2" element={<ProductionV2 />} />
                            <Route path="/production/v1" element={<Production />} />
                            <Route path="/assures" element={<Assures />} />
                            <Route path="/assures/v2" element={<AssuresV2 />} />
                            {/* Migré vers la v2 ; ancien écran conservé en /v1 pour rollback */}
                            <Route path={"/liste-des-sinistres"} element={<ListSinistresV2 />} />
                            <Route path={"/liste-des-sinistres/v1"} element={<ListSinistres />} />
                            <Route path={"/liste-des-sinistres/v2"} element={<ListSinistresV2 />} />
                            {/* v2 passée en prod : la route classique rend désormais la vue V2 (même state codeId). */}
                            <Route path={"/details-sinistre"} element={<DetailsSinistreV2 />} />
                            <Route path={"/details-sinistre/v2"} element={<DetailsSinistreV2 />} />
                            <Route path={"/inventaires"} element={<Inventaires />} />
                            {/* <Route path={'/evaluation-des-sinistres'} element={<EvaluationSinistres />} /> */}
                            <Route
                                path={"/evaluation-sinistre"}
                                element={<EvaluationSinistre />}
                            />
                            <Route path="/ajouter-courtier" element={<AddCourtier />} />
                            <Route path="/courtiers" element={<Courtiers />} />
                            <Route path="/bordereaux" element={<Bordereaux />} />
                            <Route path="/commissions-generees" element={<CommissionsGenerees />} />
                            {/* Sous-menu Commissions : recalcul des commissions nulles par agence. */}
                            <Route path="/commissions/recalcul" element={<RecalculCommissions />} />
                            <Route path="/ajouter-courtier" element={<AddCourtier />} />
                            <Route path="/courtiers" element={<Courtiers />} />
                            <Route path="/bordereaux" element={<Bordereaux />} />

                            <Route path="/contrats-imprimes" element={<PrintedContracts />} />
                            <Route path="/contrats-imprimes/v2" element={<PrintedContractsV2 />} />
                            <Route path="/attestations-cedeao-imprimees" element={<EtatAttestationsCedeaoImprimees />} />
                            <Route path="/attestations-cima-imprimees" element={<EtatAttestationsCimaImprimees />} />
                            <Route path="/contrats" element={<Contrats />} />
                            <Route
                                path="/intermediaire/:codeIntermediaire"
                                element={<DetailsIntermediaire />}
                            />
                            <Route path="/courtier/:courtierId" element={<DetailsCourtier />} />
                            <Route path="/mon-agence" element={<DetailsAgence />} />
                            <Route path="/agence/:codeAgence" element={<DetailsAgence />} />
                            <Route path="/membre/:organismeCode" element={<DetailsMembre />} />
                            <Route path="/membres" element={<AllMembres />} />

                            {/* Migration */}
                            <Route
                                path="/migration/production"
                                element={<MigrationProduction />}
                            />
                            <Route
                                path="/migration/sinistres/declarations"
                                element={<MigrationDeclarationSinistre />}
                            />
                            <Route
                                path="/migration/sinistres/payes"
                                element={<MigrationSinistrePayes />}
                            />

                            <Route
                                path="/migration/sinistres/provisions-etats"
                                element={<MigrationProvisionsEtatsDossiers />}
                            />

                            <Route path="/modifier-profil/:profilId" element={<AddProfil />} />
                            <Route path="/ajouter-profil" element={<AddProfil />} />

                            <Route
                                path="/ajouter-utilisateur-agence/:codeAgence"
                                element={<AddUtilisateur />}
                            />

                            <Route path="/ajouter-habilitation" element={<AddHabilitation />} />
                            <Route path="/habilitations" element={<Habilitations />} />
                            <Route path="/modules" element={<Modules />} />
                            <Route path="/modules/v2" element={<ModulesV2 />} />
                            <Route path="/mon-profil" element={<Profile />} />
                            <Route path="/mon-profil-securite" element={<ProfileSecurity />} />
                            <Route path="/securite/appareils" element={<AdminAppareils />} />
                            <Route
                                path="/mon-profil-notifications"
                                element={<ProfileNotifications />}
                            />

                            {/* HomeV2 est désormais la page d'accueil par défaut. */}
                            <Route path="/" index element={<HomeV2 />} />
                            <Route path="/accueil/v2" element={<HomeV2 />} />
                            {/* Ancienne page d'accueil conservée pour rollback éventuel. */}
                            <Route path="/accueil/classique" element={<Home />} />

                            {/* Routes de comptabilité */}
                            <Route path="/comptabilite/grand-livre" element={<GrandLivre />} />
                            <Route path="/comptabilite/balance" element={<Balance />} />
                            <Route path="/comptabilite/comptes" element={<Comptes />} />
                            <Route path="/comptabilite/fiscalite/tca" element={<TcaAReverser />} />
                            <Route path="/comptabilite/fiscalite/honoraires" element={<RetenuesHonoraires />} />
                            <Route path="/comptabilite/fiscalite/commissions" element={<RetenuesCommissions />} />
                            <Route path="/comptabilite/parametrage" element={<Parametrage />} />

                            <Route path="/soumettre-une-convention-de-collaboration" element={<NouvelleConventionCollaboration />} />

                            {/* Routes strictement SuperAdmin */}
                            <Route path="/email/bulk" element={<BulkEmailSender />} />
                        </Route>
                        <Route path="/download" element={<MobileAppDownloadPage />} />
                        <Route path="/admin/releases" element={<MobileAppReleasesAdmin />} />
                        <Route path="/privacy" element={<PrivacyPolicy />} />
                        <Route path="*" element={<Navigate to="/" />} />
                        <Route path="/verifier-email" element={<VerifyEmail />} />
                        <Route path="/nouveau-mot-de-passe" element={<ResetPassword />} />
                        <Route path="/mot-de-passe-oublie" element={<ForgotPassword />} />
                        <Route path="/first-connexion" element={<FirstConnexion />} />
                        <Route path="/connexion" element={<Login />} />
                        <Route path="/qr-code" element={<QrCodeGenerator />} />
                        <Route path="/waiting" element={<AfterRegistrationPage />} />
                        <Route path="/inscription" element={<Register />} />
                        <Route path="/inscription/v2" element={<RegisterV2 />} />
                        <Route
                            path="/inscription-etablissement"
                            element={<RegisterEtablissement />}
                        />
                        <Route element={<RequireAuth />}>
                            <Route path="/confirm-otp" element={<ConfirmOTP />} />
                        </Route>
                        <Route
                            path="/attestation-digitale"
                            element={<DownloadCertificates />}
                        />
                        <Route
                            path="/verification"
                            element={<InsuranceVerification />}
                        />
                        <Route
                            path="/authentifier-mon-attestation"
                            element={<CheckAuthenticity />}
                        />
                        <Route
                            path="/assets/**"
                            element={<Navigate to="/" />}
                        />
                    </Routes>
                </ResumeProvider>
                </BreadcrumbProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
